/**
 * Download Page
 *
 * Data source:
 *   Cloudflare Worker -> Feishu Bitable
 *
 * IMPORTANT:
 * Remove product-data.js from download.html.
 */


/* =========================================================
 * Configuration
 * ======================================================= */

/**
 * Replace this with your actual Cloudflare Worker API URL.
 * Example:
 * const DOWNLOAD_API_URL = 'https://fnirsi-download-api.your-name.workers.dev/api/download';
 */
const DOWNLOAD_API_URL = 'https://fnirsi-product-data-feishu-api.fnirsi001.workers.dev/api/download';

/* =========================================================
 * Global state
 * ======================================================= */
let productData = null;
let isInitialized = false;

/* =========================================================
 * DOM elements
 * ======================================================= */
const productContainer = document.getElementById('product-container');
const updateNote = document.getElementById('update-note');

/* =========================================================
 * Loading
 * ======================================================= */
function showLoading() {
    const loading = document.getElementById('loading');

    if (loading) {
        loading.style.display = 'flex';
    }
}

function hideLoading() {
    const loading = document.getElementById('loading');
    if (loading) {
        loading.style.display = 'none';
    }
}

/* =========================================================
 * Page scroll lock
 * ======================================================= */

let lockedScrollY = 0;

function lockPageScroll() {
    lockedScrollY = window.scrollY;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
}

function unlockPageScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo({
        top: lockedScrollY,
        behavior: 'instant'
    });
}

/* =========================================================
 * Overlay
 * ======================================================= */
function showOverlay() {
    const overlay = document.getElementById('overlay');
    if (overlay) {
        overlay.style.display = 'block';
    }
    lockPageScroll();
}

function hideOverlay() {
    const overlay = document.getElementById('overlay');
    if (overlay) {
        overlay.style.display = 'none';
    }
    unlockPageScroll();
}

/* =========================================================
 * Error UI
 * ======================================================= */
function showLoadError(error) {
    console.error('Failed to load product data:', error);

    if (!productContainer) {return;}

    productContainer.innerHTML = '';

    const errorBox = document.createElement('div');
    errorBox.style.padding = '30px';
    errorBox.style.background = '#fff2f2';
    errorBox.style.borderRadius = '12px';
    errorBox.style.margin = '20px 0';

    const title = document.createElement('h3');
    title.textContent = 'Unable to load download data';
    title.style.marginTop = '0';

    const message = document.createElement('p');
    message.textContent = 'Please refresh the page and try again.';

    const detail = document.createElement('p');
    detail.style.fontSize = '13px';
    detail.style.color = '#777';
    detail.textContent = error?.message || 'Unknown error';

    errorBox.appendChild(title);
    errorBox.appendChild(message);
    errorBox.appendChild(detail);
    productContainer.appendChild(errorBox);
}

/* =========================================================
 * Load data from Cloudflare Worker
 * ======================================================= */
async function loadProductData() {
    if (!DOWNLOAD_API_URL || DOWNLOAD_API_URL.includes('YOUR-WORKER')) {
        throw new Error('Please configure DOWNLOAD_API_URL in download.js');
    }
    const response = await fetch(DOWNLOAD_API_URL, {
        method: 'GET',
        headers: {'Accept':'application/json'},
        cache: 'no-store'
    });
    if (!response.ok) {
        throw new Error(`API request failed: HTTP ${response.status}`);
    }
    const data = await response.json();
    if (!data || !Array.isArray(data.categories)) {
        throw new Error('Invalid product data returned by API');
    }
    return data;
}

/* =========================================================
 * Initialize page
 * ======================================================= */
async function init() {
    showLoading();
    try {
        /*
        * Load data from Cloudflare Worker.
        * This replaces the old:
        * <script src="product-data.js"></script>
        */
        productData = await loadProductData();
        console.log('productData =', productData);
        initializeUI();
    } catch (error) {
        showLoadError(error);
    } finally {
        hideLoading();
    }
}

/* =========================================================
 * Initialize UI
 * ======================================================= */
function initializeUI() {
    if (!productData) {return;}
    const params = new URLSearchParams(window.location.search);
    const categoryParam = params.get('category');
    let currentCategory = null;

    /* -----------------------------------------------
    * Filter header
    * --------------------------------------------- */
    const filterHeader = document.createElement('div');
    filterHeader.setAttribute('id', 'filter-header');

    const filterTitle = document.createElement('h2');
    filterTitle.textContent = 'Filter';
    filterHeader.appendChild(filterTitle);

    const filterCloseBtn = document.createElement('button');
    filterCloseBtn.setAttribute('id', 'close-filter-btn');
    filterCloseBtn.textContent = '×';
    filterHeader.appendChild(filterCloseBtn);

    const filter = document.getElementById('product-filter');
    filter.innerHTML = '';
    filter.appendChild(filterHeader);

    /* -----------------------------------------------
    * Category list
    * --------------------------------------------- */
    const productFilterContainer = document.createElement('div');
    productFilterContainer.classList.add('category-list');

    /*
    * Loop through all categories
    */
    productData.categories.forEach(category => {
        if (categoryParam && categoryParam === category.categoryId) {
            currentCategory = category;
        }

        /*
        * Category container
        */
        const categoryItem = document.createElement('div');
        categoryItem.classList.add('category-item');
        categoryItem.setAttribute('id', category.categoryId);

        /*
        * Sub-category list
        */
        const subCategoryList = document.createElement('div');
        subCategoryList.classList.add('sub-category-list');
        const subCategories = Array.isArray(category.subCategories) ? category.subCategories : [];

        subCategories.forEach(subCategory => {
            const subCategoryName = document.createElement('p');
            subCategoryName.textContent = subCategory.categoryName || '';
            subCategoryList.appendChild(subCategoryName);
        });

        /*
        * Category image
        */
        const categoryImage = document.createElement('img');
        categoryImage.src = category.categoryImage || '';
        categoryImage.alt = category.categoryName || '';
        categoryItem.appendChild(categoryImage);

        /*
        * Category name
        */
        const categoryName = document.createElement('p');
        categoryName.textContent = category.categoryName || '';
        categoryItem.appendChild(categoryName);

        /*
        * Category click
        */
        categoryItem.addEventListener('click', event => {
            event.preventDefault();
            const dataCategory = event.currentTarget.getAttribute('id');
            history.pushState(null, '', '?category=' + encodeURIComponent(dataCategory));
            if (dataCategory === 'all-devices') {
                displayAllCategories(0);
            } else {
                displayCategoryProducts(category, true);
            }

            /*
            * Hide filter on
            * mobile/tablet
            */
            if (window.innerWidth <= 1024) {
                closeProductFilter();
            }
        });

        productFilterContainer.appendChild(categoryItem);
        productFilterContainer.appendChild(subCategoryList);
    });

    filter.appendChild(productFilterContainer);

    /* -----------------------------------------------
    * Initial product display
    * --------------------------------------------- */
    if (currentCategory !== null && currentCategory.categoryId !== 'all-devices') {
        displayCategoryProducts(currentCategory, true);
    } else {
        displayAllCategories(1);
    }

    /* -----------------------------------------------
    * Mobile filter button
    * --------------------------------------------- */
    const filterBtn = document.getElementById('filter-btn');
    if (filterBtn) {
        /*
        * Remove previous handler
        * to avoid duplicate events
        */
        filterBtn.onclick = () => {
            toggleProductFilter();
        };
    }


    /* -----------------------------------------------
    * Overlay
    * --------------------------------------------- */
    const overlay = document.getElementById('overlay');
    if (overlay) {
        overlay.onclick = () => {
            const modal = document.getElementById('modal');
            const productFilter = document.getElementById('product-filter');

            // Modal is open
            if (modal && modal.style.display === 'flex') {
                closeModal();
                return;
            }

            // Filter is open
            if (productFilter && productFilter.style.left === '0px') {
                closeProductFilter();
            }
        };
    }

    /* -----------------------------------------------
    * Close filter button
    * --------------------------------------------- */
    const closeBtn = document.getElementById('close-filter-btn');
    if (closeBtn) {
        closeBtn.onclick = () => {
            closeProductFilter();
        };
    }

    isInitialized = true;
}

/* =========================================================
 * Display products of selected category
 * ======================================================= */
function displayCategoryProducts(category,isClear) {
    if (!category) {return;}

    /*
    * Clear previous product list
    */
    if (isClear) {
        productContainer.innerHTML = '';
        setCategoryActive(category);
    }

    /*
    * Category container
    */
    const categoryDiv = document.createElement('div');
    categoryDiv.classList.add('category');

    /*
    * Category title
    */
    const categoryTitle = document.createElement('h2');
    categoryTitle.textContent = category.categoryName || '';
    categoryDiv.appendChild(categoryTitle);

    /*
    * Product list
    */
    const productList = document.createElement('div');
    productList.classList.add('product-list');
    const subCategories = Array.isArray(category.subCategories) ? category.subCategories : [];

    /*
    * Loop through subcategories
    */
    subCategories.forEach(subCategory => {
        /*
        * Hide title for
        * "other-devices"
        */
        if (subCategory.categoryId !== 'other-devices') {
            const subCategoryTitle = document.createElement('h3');
            subCategoryTitle.classList.add('sub-category-title');
            subCategoryTitle.textContent = subCategory.categoryName || '';
            productList.appendChild(subCategoryTitle);
        }

        /*
        * Products
        */
        const products = Array.isArray(subCategory.products) ? subCategory.products : [];
        products.forEach(product => {
            /*
            * Product container
            */
            const productDiv = document.createElement('div');
            productDiv.classList.add('product');

            /*
            * Product image
            */
            const productImage = document.createElement('img');
            productImage.src = product.image || '';
            productImage.alt = product.model || product.productName || '';
            productDiv.appendChild(productImage);

            /*
            * Product model
            */
            const productModel = document.createElement('div');
            const modelText = document.createElement('p');
            modelText.textContent = `FNIRSI® ${product.model || ''}`;
            productModel.appendChild(modelText);

            /*
            * Product status
            */
            if (product.status) {
                const status = document.createElement('p');
                status.textContent = product.status;
                if (product.status ==='Coming Soon') {
                    status.classList.add('badge-blue');
                } else {
                    status.classList.add('badge');
                }
                // 当状态是On Sale时不添加元素
                if (product.status != "On Sale"){
                    productModel.appendChild(status);
                }
            }
            productDiv.appendChild(productModel);

            /*
            * Open modal
            */
            productDiv.addEventListener('click', () => {
                openModal(product);
            });
            productList.appendChild(productDiv);
        });
    });

    categoryDiv.appendChild(productList);
    productContainer.appendChild(categoryDiv);

    /*
    * Scroll to top
    */
    if (isClear && updateNote) {
        window.scrollTo({
            top: updateNote.offsetTop,
            behavior: 'smooth'
        });
    }
}

/* =========================================================
 * Display all categories
 * ======================================================= */
function displayAllCategories(loadTime) {
    productContainer.innerHTML = '';

    if (!productData || !Array.isArray(productData.categories)) {return;}

    productData.categories.forEach(category => {
        if (category.categoryId !== 'all-devices') {
            displayCategoryProducts(category,false);
        } else {
            setCategoryActive(category);
        }
        }
    );

    /*
    * Scroll
    */
    if (loadTime === 1 && updateNote) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    } else if (loadTime === 0 && updateNote) {
        window.scrollTo({
            top: updateNote.offsetTop,
            behavior: 'smooth'
        });
    }
}

/* =========================================================
 * Open product modal
 * ======================================================= */
function openModal(product) {

    if (!product) {return;}

    /*
    * Model
    */
    const modalModel = document.getElementById('modal-model');
    if (modalModel) {
        modalModel.textContent = product.model || '';
    }

    /*
    * Image
    */
    const modalImage = document.getElementById('modal-image');
    if (modalImage) {
        modalImage.src = product.image || '';
        modalImage.alt = product.model || product.productName || '';
    }

    /*
    * Product title
    */
    const modalTitle = document.getElementById('modal-title');
    if (modalTitle) {
        modalTitle.textContent = product.productName || '';
    }

    /*
    * View product button
    */
    const viewProductBtn = document.getElementById('modal-btn');
    const viewProductBtnNot = document.getElementById('modal-btn-not');

    if (product.url === '') {
        if (product.status === 'Coming Soon') {
            viewProductBtnNot.textContent = 'Coming Soon';
        } else {
            viewProductBtnNot.textContent = 'Not Available';
        }

        viewProductBtn.style.display = 'none';
        viewProductBtnNot.style.display = 'block';
    } else {
        viewProductBtn.href = product.url;
        viewProductBtn.target = '_blank';
        viewProductBtnNot.style.display = 'none';
        viewProductBtn.style.display = 'block';
    }

    /*
    * Populate files
    */
    populateLinks('manuals',product.manuals);
    populateLinks('firmwares',product.firmwares);
    populateLinks('updateTool',product.updateTool);
    populateLinks('updateTutorial',product.updateTutorial);

    /*
    * Show modal
    */
    const modal = document.getElementById('modal');
    if (modal) {
        modal.style.display = 'flex';
    }
    
    showOverlay();
}

/* =========================================================
 * Close modal
 * ======================================================= */
function closeModal() {
    const modal = document.getElementById('modal');

    if (modal) {
        modal.style.display = 'none';
    }

    hideOverlay();
}

/* =========================================================
 * Populate download links
 * ======================================================= */
function populateLinks(sectionId,items) {
    const section = document.getElementById(`${sectionId}-section`);
    const container = document.getElementById(sectionId);

    if (!section || !container) {return;}

    /*
    * Remove old rows
    */
    const oldRows = container.querySelectorAll('.table-row');

    oldRows.forEach(
        row => row.remove()
    );

    /*
    * Normalize items
    */
    if (!Array.isArray(items) || items.length === 0) {
        section.style.display = 'none';
        return;
    }
    section.style.display = 'block';

    /*
    * Sort firmware by Sequential ID
    *
    * Only firmwares are sorted.
    * Larger numeric Sequential ID comes first.
    */
    let sortedItems = [...items];

    if (sectionId === 'firmwares') {
        sortedItems.sort((a, b) => {
            const idA = Number(a?.sequentialId);
            const idB = Number(b?.sequentialId);

            /*
            * Valid numeric IDs:
            * larger number comes first
            */
            if (!Number.isNaN(idA) && !Number.isNaN(idB)) {
                return idB - idA;
            }

            /*
            * If one ID is invalid or empty,
            * put the invalid one after the valid one.
            */
            if (!Number.isNaN(idA)) {
                return -1;
            }

            if (!Number.isNaN(idB)) {
                return 1;
            }

            return 0;
        });
    }

    /*
    * Create rows
    */
    sortedItems.forEach(item => {
        if (!item) {return;}

        const row = document.createElement('div');
        row.className = 'table-row';

        /*
        * Name cell
        */
        const nameCell = document.createElement('div');
        nameCell.className = 'cell';
        nameCell.textContent = item.name || '';

        /*
        * Link cell
        */
        const linkCell = document.createElement('div');
        linkCell.className = 'cell';

        if (item.url) {
            const link =document.createElement('a');
            link.href = item.url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.textContent = item.btnText || 'Download';
            linkCell.appendChild(link);
        }


        row.appendChild(nameCell);
        row.appendChild(linkCell);
        container.appendChild(row);
    });
}

/* =========================================================
 * Toggle mobile/tablet filter
 * ======================================================= */
function toggleProductFilter() {
    const productFilter = document.getElementById('product-filter');
    const overlay = document.getElementById('overlay');

    if (!productFilter || !overlay) {return;}

    /*
    * Existing CSS controls
    * the mobile position using
    * left property.
    */
    if (productFilter.style.left === '0px') {
        closeProductFilter();
    } else {
        productFilter.style.left = '0px';
        overlay.style.display = 'block';
        lockPageScroll();
    }
}

/* =========================================================
 * Close mobile/tablet filter
 * ======================================================= */
function closeProductFilter() {
    const productFilter = document.getElementById('product-filter');
    const overlay = document.getElementById('overlay');

    if (productFilter) {
        productFilter.style.left = '-500px';
    }

    if (overlay) {
        overlay.style.display = 'none';
        unlockPageScroll();
    }

    /*
    * Preserve existing behavior.
    */
    const modalBtn = document.getElementById('modal-btn');
    if (modalBtn) {
        modalBtn.href = '/';
    }
}

/* =========================================================
 * Set active category
 * ======================================================= */
function setCategoryActive(category) {
    if (!category) {
        return;
    }

    /*
    * Remove all active states
    */
    document.querySelectorAll('.category-item.active').forEach(element => {
        element.classList.remove('active');
        const subList = element.nextElementSibling;

        if (subList && subList.classList.contains('sub-category-list')) {
            subList.style.height = '0px';
        }
    });

    /*
    * Find current category
    */
    const activeItem = document.getElementById(category.categoryId);

    if (!activeItem) {return;}
    activeItem.classList.add('active');

    /*
    * Expand sub-category list
    */
    const currentSubList = activeItem.nextElementSibling;
    if (currentSubList && currentSubList.classList.contains('sub-category-list')) {
        currentSubList.style.height = currentSubList.scrollHeight + 'px';
    }
}

/* =========================================================
 * Page events
 * ======================================================= */
window.addEventListener('load',init);

/*
 * Browser back / forward
 *
 * Important:
 * Do NOT request Feishu data again.
 *
 * We already have productData.
 */
window.addEventListener('popstate',() => {
    if (!productData) {return;}
    initializeUI();
});